import imageCompression from 'browser-image-compression';

const MAX_SIZE_MB = 2;
const MAX_DIMENSION = 4096;

/**
 * Compress an image file if it exceeds the size threshold.
 * Returns the original file unchanged for non-images or files already under the limit.
 */
export async function compressImage(file: File): Promise<File> {
  if (!file.type.startsWith('image/')) {
    return file;
  }

  if (file.size <= MAX_SIZE_MB * 1024 * 1024) {
    return file;
  }

  const compressed = await imageCompression(file, {
    maxSizeMB: MAX_SIZE_MB,
    maxWidthOrHeight: MAX_DIMENSION,
    useWebWorker: true,
    preserveExif: true,
  });

  return new File([compressed], file.name, { type: compressed.type });
}
